import * as React from 'react';
const SvgResponsive = (props) => (
  <svg viewBox="0 0 139 122" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#responsive_svg__a)"
      stroke="#000"
      strokeWidth={3.5}
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M88.613 76.31H2.066M90.673 119.932H32.576c0-6.738 5.455-12.193 12.179-12.193h43.858M57.755 101.847l3.158-7.783M80.82 98.815l3.62 8.918M105.952 53.858h27.422a3.562 3.562 0 0 1 3.56 3.564v58.94a3.562 3.562 0 0 1-3.56 3.564h-31.75a3.562 3.562 0 0 1-3.56-3.564V75.548" />
      <path d="M136.302 45.731V9.663a7.59 7.59 0 0 0-7.598-7.595H9.652c-4.185 0-7.586 3.399-7.586 7.595v76.363c0 4.202 3.4 7.594 7.586 7.594h78.96M54.053 27.842l66.469 52.812" />
      <path d="m102.87 81.481 17.876-.65-3.424-17.576M71.805 27.091l-17.882.65 3.43 17.577" />
    </g>
    <defs>
      <clipPath id="responsive_svg__a">
        <path fill="#fff" d="M0 0h139v122H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgResponsive;
